import { MenuItem, Stack, TextField, Typography } from '@mui/material';
import { IPersonalDetails } from 'API';
import { ControllerSelect, CustomCheckbox, FormSection } from 'Components';
import { Dictionary } from 'Dictionary';
import { DICTIONARY } from 'Enum';
import { useAppSelector, useDictionary, useIsDesktop } from 'Hooks';
import { useEffect } from 'react';
import { useFormContext, useWatch } from 'react-hook-form';
import { generateError } from 'Regex';
import { styleTextField } from 'Theme';
import { textFieldShrink } from 'Utils';

export const hmoStillInMilitaryServiceId = 5;

export const FourthSection = () => {
  const {
    register,
    formState: {
      errors: { hmoSection },
    },
    clearErrors,
    setValue,
  } = useFormContext<IPersonalDetails>();
  const hmOs = useAppSelector(
    ({
      generalContent: {
        generalContent: { hmOs },
      },
    }) => hmOs
  );

  const isDesktop = useIsDesktop();
  const dictionary = useDictionary(Dictionary, DICTIONARY.PERSONAL_DETAILS);

  const hmoRelationIdName = 'hmoSection.hmoRelationId';

  const hmoRelationId = useWatch({
    name: hmoRelationIdName,
    defaultValue: 0,
  }) as number;

  const [hasNoDoctorName, doctorsNameAndSpecialization] = useWatch({
    name: [
      'hmoSection.hasNoDoctorName',
      'hmoSection.doctorsNameAndSpecialization',
    ],
  });

  const doctorsNameAndSpecializationName =
    'hmoSection.doctorsNameAndSpecialization';

  useEffect(() => {
    if (hasNoDoctorName) {
      setValue('hmoSection.doctorsNameAndSpecialization', '');
      clearErrors(doctorsNameAndSpecializationName);
    }
  }, [clearErrors, setValue, hasNoDoctorName]);

  return (
    <FormSection grouped id={dictionary.fourthSectionTitle}>
      <Typography
        fontSize={isDesktop ? '18px !important' : '16px !important'}
        sx={{ fontWeight: 'bold' }}
        id={dictionary.fourthSectionTitle}
      >
        {dictionary.fourthSectionTitle}
      </Typography>
      <Stack>
        <Typography>{dictionary.fourthSectionSubTitle}</Typography>
        <Typography>{dictionary.fourthSectionSubTitle2}</Typography>
      </Stack>
      <ControllerSelect
        name={hmoRelationIdName}
        label={dictionary.fourthSectionFirstInput}
      >
        {hmOs.map(({ value, id }) => (
          <MenuItem key={id} value={id}>
            {value}
          </MenuItem>
        ))}
      </ControllerSelect>
      {hmoRelationId != hmoStillInMilitaryServiceId && (
        <Stack>
          <TextField
            role={
              Boolean(hmoSection?.doctorsNameAndSpecialization)
                ? 'alert'
                : undefined
            }
            id={dictionary.fourthSectionSecondInput}
            inputProps={{
              maxLength: '50',
            }}
            {...register(doctorsNameAndSpecializationName)}
            label={dictionary.fourthSectionSecondInput}
            {...textFieldShrink(doctorsNameAndSpecialization)}
            error={Boolean(hmoSection?.doctorsNameAndSpecialization)}
            helperText={
              Boolean(hmoSection?.doctorsNameAndSpecialization?.message) &&
              generateError(
                dictionary.fourthSectionSecondInput,
                hmoSection?.doctorsNameAndSpecialization?.message!
              )
            }
            disabled={hasNoDoctorName}
            sx={styleTextField}
          />
          <CustomCheckbox
            name={'hmoSection.hasNoDoctorName'}
            label={dictionary.noInfo}
          />
        </Stack>
      )}
    </FormSection>
  );
};
